/* eslint class-methods-use-this: ["error", { "exceptMethods": ["adjData","sendMaxnervaLog","dynamicSort","makeCityOption","resetCityOption"] }] */
import { EventEmitter } from 'events';
import { tmpl, verityInput, getSpecialTip } from '@/utils/util-extent';
import LocationMap from './LocationMap';
import LocationListItem from './LocationListItem';

const { $ } = window;

const RANGE = 1000;// km 設定無限大

export default class LocationViewer extends EventEmitter {
  /**
     * Creates an instance of LocationViewer.
     *
     * @param {any} type: "1":展示中心, "2":維修據點, "3": 充電站
     * @param {any} $container
     *
     * @memberOf LocationViewer
     */
  constructor(type, $container, opt) {
    super();
    const self = this;
    this.opt = $.extend({
      useGPS: true,
      isScrollListByMarker: false,
      isListItemCheckable: false,
      iconUrl: '/images/icons/location-pin.png',
      showMap: true,
      isMaxnervaLog: false,
    }, opt);

    this.locationType = type;
    this.$container = $container;
    // dynamicdom
    // this.$tabCity = this.$container.find('.filter-panel .tabs .tab[data-tab-id="city"]');
    // this.$tabKeyword = this.$container.find('.filter-panel .tabs .tab[data-tab-id="keyword"]');
    // this.$tabPosition = this.$container.find('.filter-panel .tabs .tab[data-tab-id="position"]');
    this.$city = this.$container.find('.location-search .search-filter-city select'); // 縣市下拉選單
    this.$area = this.$container.find('.location-search .search-filter-cityarea select'); // 鄉鎮下拉選單
    // this.$store = this.$container.find('.filters .store'); //
    this.$keyword = this.$container.find('.location-search .search-filters-input input'); // 關鍵字 地址 查詢
    this.$listW = this.$container.find('.location-maps-wrapper'); // 控制右邊訊息視窗開關
    this.$scrollInfoDom = this.$container.find('.store-list'); // 控制右邊訊息視窗scroll
    this.$listContent = this.$container.find('.store-list'); // 預備建置訊息視窗內容
    this.list = []; // 取得從 api 傳回資料
    this.listShowed = false; // 判斷是否開啟右邊詳細訊息視窗
    this.currentList = []; // 存放過濾搜尋條件的資料
    this.updateMapDelayer = null;
    this.currentFilter = 'city'; // 過濾搜尋條件類型 city keyword 其他為所在位置
    // this.currentPostion = null;
    this.items = []; // 存放 LocationListItem
    this.checkedItemData = null; // 取得選取回傳
    this.summary = this.$container.find('.search-result-summary'); // 搜尋結果
    this.backProp = null;
    this.islinkDirect = false;
    LocationMap.ICON_URL = this.opt.iconUrl;

    // this.$container.find('.list .title').html($('#template-location-viewer-list-title').html()); // dynamicdom

    $('.results-toggler').on('click', () => {
      if (self.$listW.hasClass('hide-list')) {
        self.openList(false);
      } else {
        self.openList(true);
      }
    });

    $('#getGeoLocation').on('click', () => {
      this.currentFilter = 'position';
      this.updateMap();
      this.openList();
    });

    if (!this.opt.showMap) this.openList(true);

    if (this.opt.list !== undefined) {
      this.onLoadList(this.opt.list);
    } else {
      this.loadList();
    }

    this.summary.hide();
    this.summary.find('.link-icon-append').on('click', (e) => {
      e.preventDefault();
      let directType;
      if (this.locationType === '1') {
        directType = '2';
      } else if (this.locationType === '2') {
        directType = '1';
      }
      // 紀錄目前使用參數
      this.backProp = { city: this.$city.val(), area: this.$area.val(), keyword: this.$keyword.val() };
      this.islinkDirect = true;
      $(`input[name=locationType][value=${directType}]`).trigger('click');
    });
  }

  // 排除特定縣市 by MarkVann → 傳入要排除的縣市名稱列表
  excludeCities(list) {
    const { listBackup: backup } = this;
    if (!backup) {
      setTimeout(this.excludeCities.bind(this), 250, list);
      return;
    }
    const list2 = backup.filter(({ city }) => (list.indexOf(city) < 0));
    this.updateFilter(list2);
  }

  // 只留特定據點 by MarkVann → 傳入要保留的據點KEY列表
  targetStores(list) {
    const { listBackup: backup } = this;
    if (!backup) {
      setTimeout(this.targetStores.bind(this), 250, list);
      return;
    }
    const list2 = backup.filter(({ key }) => (list.indexOf(key) > -1));
    this.updateFilter(list2);
  }

  makeCityOption(list) {
    const option = {};
    let item;
    for (let index = 0; index < list.length; index += 1) {
      item = list[index];
      if (!option[item.city]) option[item.city] = [];
      if (option[item.city].indexOf(item.area) === -1) option[item.city].push(item.area);
    }
    return option;
  }

  resetCityOption(option) {
    const { $city: city, $area: area } = this;
    city.empty();
    area.empty();
    city.append('<option value="">請選擇</option>');
    area.append('<option value="">請選擇區域</option>');
    Object.keys(option).forEach((key) => {
      city.append(
        tmpl('<option value="{{ CITY }}">{{ CITY }}</option>', { CITY: key }), // dynamicdom
      );
    });
  }

  updateFilter(list) {
    if (!this.listBackup) return;
    let newList;
    if (!list) {
      newList = this.listBackup;
    } else {
      newList = list;
    }
    const option = this.makeCityOption(newList);
    this.resetCityOption(option);
    this.cityOption = option;
    this.list = newList;
    this.currentList = [];
    this.map.updateNewMarkers(newList);
    this.openList(false);
    this.$listContent.empty();
    this.$listW.addClass('hide-list');
    this.$keyword.val('');
    this.currentPosition = null;
    this.summary.hide();
    if (this.opt.useGPS) {
      this.getCurrentPosition();
    }
    if (this.islinkDirect) {
      if (this.currentFilter === 'city') {
        this.$city.val(this.backProp.city);
        this.onCityChange();
      } else {
        this.$keyword.val(this.backProp.keyword);
        this.updateMap();
      }
    }
  }

  loadList(isInit = true) {
    // var list = require("./LocationData.js");
    $.ajax({
      url: 'api/location.ashx',
      type: 'POST',
      dataType: 'json',
      data: {
        TYPE: this.locationType,
      },
    })
      .done((e) => {
        if (e.RS === 'OK') {
          if (isInit) {
            this.onLoadList(this.adjData(e.DATA));
          } else {
            this.updateFilter(this.adjData(e.DATA));
          }
        } else {
          console.log(e.RS);
        }
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        // console.log('complete');
      });
    // this.onLoadList(list);
  }

  onLoadList(list) {
    this.list = list.slice(0);
    if (this.opt.showMap) {
      this.initMap();
    }
    this.initCityFilter();

    if (this.opt.useGPS) {
      this.getCurrentPosition();
    }
    this.ready();
  }

  adjData(list) {
    const newList = [];
    let item; let lat; let lng;
    for (let key = 0; key < list.length; key += 1) {
      item = list[key];
      lat = parseFloat(item.LAT);
      lng = parseFloat(item.LNG);
      if (!Number.isNaN(lat) && !Number.isNaN(lng) && lat !== 0 && lng !== 0) {
        newList.push({
          lat,
          lng,
          key: item.KEY,
          title: `${item.DEALER}豐田 ${item.TITLE}`,
          dealer: item.DEALER,
          type: item.TYPE,
          city: item.CITY,
          area: item.AREA,
          address: item.ADDR,
          tel: item.TEL,
          time: item.TIME,
          aed: (item.AED === '1'),
          exclusive: (item.EXCLUSIVE === 'Y'),
          ebisflag: (item.EBISFLAG === 'Y'),
          ntisflag: (item.NTISFLAG === 'Y'),
          bpisflag: (item.BPISFLAG === 'Y'),
          dateInfo: item.DATEINFO,
          exclusiveCars: item.EXCLUSIVECARS, // 展示及維護
          carHeightType: item.CARHEIGHTTYPE, // 限高樣式
          limitHeight: item.LIMITHEIGHT, // 限高
        });
      }
    }

    return newList;
  }

  initMap() {
    const $map = this.$container.find('#maps');// dynamicdom
    $map.empty();
    this.map = new LocationMap($map[0], this.list);
    this.map.on(LocationMap.MARKER_CLICK, this.onMarkerClick.bind(this));
  }

  initCityFilter() {
    const cityOption = {};
    let item;
    this.$city.append('<option value="">請選擇</option>');
    for (let key = 0; key < this.list.length; key += 1) {
      item = this.list[key];
      if (!cityOption[item.city]) {
        cityOption[item.city] = [];
        this.$city.append(tmpl('<option value="{{ CITY }}">{{ CITY }}</option>', {
          CITY: item.city,
        }));
      }
      if (cityOption[item.city].indexOf(item.area) === -1) {
        cityOption[item.city].push(item.area);
      }
    }
    this.$area.html('<option value="">請選擇區域</option>').prop('disabled', true);
    this.$city.on('change', this.onCityChange.bind(this));
    this.$area.on('change', this.onAreaChange.bind(this));
    // if (this.$store[0]) {
    //   this.$store.on('change', this.onStoreSelChange.bind(this));
    // }

    this.cityOption = cityOption;
    this.listBackup = this.list.concat();
  }

  onCityChange() {
    this.$area.html('<option value="">請選擇區域</option>'); // dynamicdom
    if (this.$city.val() !== '') {
      const areas = this.cityOption[this.$city.val()];
      for (let i = 0; i < areas.length; i += 1) {
        this.$area.append(tmpl('<option value="{{ AREA }}">{{ AREA }}</option>', {
          AREA: areas[i],
        }));
      }
      if (this.islinkDirect) {
        if (areas.indexOf(this.backProp.area) > -1) {
          this.$area.val(this.backProp.area);
        } else {
          this.$area.append(tmpl('<option value="{{ AREA }}">{{ AREA }}</option>', {
            AREA: this.backProp.area,
          }));
        }
      }
    }
    this.$area.prop('disabled', false);
    this.onAreaChange();
  }

  onAreaChange() {
    this.$keyword.val('');
    this.currentFilter = 'city';// this.$tabCity.trigger('click');
    this.updateMap();
    this.openList();
  }

  //   onStoreSelChange() {
  //     if (!this.$store[0]) return;

  //     const store = this.$store.val();
  //     let item;
  //     for (let key = 0; key < this.list.length; key += 1) {
  //       item = this.items[key];
  //       item.check(item.data.key === store, true);
  //     }
  //     if (store !== '') {
  //       this.scrollListByKey(store);
  //     }
  //   }

  onKeywordSubmit(e) {
    e.preventDefault();
    if (this.$keyword.val().length < 1 || verityInput(this.$keyword.val(), 'htmltag') === false) {
      alert(getSpecialTip());
      return false;
    }
    this.$city.val('');
    this.$area.val('');
    this.$city[0].selectedIndex = 0;
    this.$area[0].selectedIndex = 0;
    $('.location-search .search-filter-city #select2--container').text('請選擇');
    $('.location-search .search-filter-cityarea #select2--container').text('請選擇區域');

    this.currentFilter = 'keyword';// this.$tabKeyword.trigger('click');
    this.updateMap();
    this.openList();
    return false;
  }

  getCurrentPosition(cb) {
    // if (window.location.href.indexOf('toyota') !== -1) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.onGetCurrentPosition(position, cb);
      }, (e) => {
        console.log('geolocation error:');
        for (let i = 0; i < e.length; i += 1) {
          console.log(i, ':', e[i]);
        }
      });
    }
    // } else {
    //   this.onGetCurrentPosition({
    //     coords: {
    //       latitude: 25.038341,
    //       longitude: 121.080813,
    //     },
    //   }, cb);
    // }
    /*
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function(position) {
                this.onGetCurrentPosition(position, cb);
            }.bind(this));
        }
        */
  }

  onGetCurrentPosition(position, cb) {
    this.currentPosition = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    this.map.currentPosition = this.currentPosition;

    if (this.list) {
      let item;
      for (let key = 0; key < this.list.length; key += 1) {
        item = this.list[key];
        item.dist = Math.round(LocationMap.getDistance(
          item.lat,
          item.lng,
          this.currentPosition.lat,
          this.currentPosition.lng,
        ));
        item.directionLink = this.map.getDirectionLink(item.lat, item.lng);
      }
    }

    if (cb !== undefined) cb();
  }

  updateMap() {
    if (this.updateMapDelayer) clearTimeout(this.updateMapDelayer);
    this.updateMapDelayer = setTimeout(this.updateMapDelay.bind(this), 100);
  }

  updateMapDelay() {
    let item;
    const q = { type: this.locationType };
    if (this.currentFilter === 'city') {
      if (this.$city.val().length > 0) {
        q.city = this.$city.val();
      }
      if (this.$area.val().length > 0) {
        q.area = this.$area.val();
      }
      if (q.city || q.area) this.sendMaxnervaLog(q.city, q.area, undefined);
    } else if (this.currentFilter === 'keyword') {
      const keyword = this.$keyword.val();
      if (keyword.length > 0) {
        q.keyword = keyword;
        this.sendMaxnervaLog(undefined, undefined, q.keyword);
      }
    }

    this.currentList = [];

    if (this.currentFilter === 'city') {
      for (let key = 0; key < this.list.length; key += 1) {
        item = this.list[key];
        this.isMatch = false;
        if (item.type === q.type || q.type === '0') {
          if (!q.city && !q.area) {
            this.isMatch = true;
          } else if (!q.area) {
            if (item.city === q.city) this.isMatch = true;
          } else if (item.city === q.city && item.area === q.area) this.isMatch = true;

          if (this.isMatch) {
            this.currentList.push(item);
          }
        }
      }
    } else if (this.currentFilter === 'keyword') {
      for (let key = 0; key < this.list.length; key += 1) {
        item = this.list[key];
        this.isMatch = false;
        if (q.keyword !== undefined && (item.type === q.type || q.type === '0')) {
          if (item.title.indexOf(q.keyword) !== -1 || item.address.indexOf(q.keyword) !== -1) {
            this.isMatch = true;
          }
        }
        if (this.isMatch) this.currentList.push(item);
      }
    } else if (this.CurrentPosition) {
      const list = [];
      for (let key = 0; key < this.list.length; key += 1) {
        item = this.list[key];
        // console.log(item.type, q.type, RANGE, item.dist, item.dist < RANGE);
        if ((item.dist < RANGE) && (item.type === q.type || q.type === '0')) {
          list.push(item);
        }
      }
      if (list.length > 0) {
        list.sort(this.dynamicSort('dist'));
      }
      this.currentList = list.slice(0, 3);
    }

    this.islinkDirect = false; // reset
    this.updateMapMarkers();
    this.updateList();
    this.updateSummary();
  }

  updateMapMarkers() {
    if (this.map) this.map.updateVisibleMarkers(this.currentList);
  }

  updateList() {
    this.$listContent.empty().scrollTop(0);

    // var html = $("#template-map-item").html();
    this.checkedItemData = null;
    this.items = [];
    let item;
    for (let key = 0; key < this.currentList.length; key += 1) {
      const data = this.currentList[key];
      item = new LocationListItem(this.$listContent, data, {
        isCheckable: this.opt.isListItemCheckable,
        isViewMarkerItems: this.opt.isViewMarkerItems,
      });
      item.on(LocationListItem.CLICK, this.onListItemClick.bind(this));
      item.on(LocationListItem.CHECK, this.onListItemCheck.bind(this));
      this.items.push(item);
    }
    // this.updateStoreSel();
    if (this.currentList.length > 0) this.$listW.removeClass('hide-list');
  }

  updateSummary() {
    let currentTypeName;
    let optiontypeName;
    if (this.locationType === '1') {
      currentTypeName = '展示中心';
      optiontypeName = '維修據點';
    } else if (this.locationType === '2') {
      currentTypeName = '維修據點';
      optiontypeName = '展示中心';
    }
    this.summary.show();
    this.summary.find('.text-primary').text(this.currentList.length);
    this.summary.find('.search-type').text(currentTypeName);
    this.summary.find('.link-icon-append').empty();
    this.summary.find('.link-icon-append').append(`${optiontypeName}<i class="icon icon-arrow"></i>`);
  }
  //   updateStoreSel() {
  //     if (!this.$store[0]) return;

  //     this.$store.html('<option value="">請選擇服務廠</option>');// dynamicdom
  //     let item;
  //     for (let key = 0; key < this.currentList.length; key += 1) {
  //       item = this.currentList[key];
  //       // this.$store.append('<option value="{KEY}">{NAME}</option>'.replace(/{AREA}/g, areas[i]));
  //       this.$store.append(tmpl('<option value="{{ KEY }}">{{ TITLE }}</option>', {
  //         KEY: item.key,
  //         TITLE: item.title,
  //       }));
  //     }
  //   }

  onListItemClick(key) {
    if (this.map) this.map.panByMarkerKey(key);
  }

  onListItemCheck(data) {
    // const key = data ? data.key : '';
    // let item;
    // for (let i = 0; i < this.items.length; i += 1) {
    //   item = this.items[i];
    //   // console.log(item.data.key, key);
    //   if (item.data.key !== key) {
    //     item.$item.removeClass('CHECKED');
    //   }
    // }
    // if (this.$store[0]) this.$store.val(key);
    this.checkedItemData = data;
    this.emit(LocationViewer.LIST_ITEM_CHECK, data);
  }

  onMarkerClick(key) {
    if (!this.listShowed) this.openList();
    if (this.opt.isScrollListByMarker) {
      this.scrollListByKey(key);
    }
  }

  scrollListByKey(key) {
    let $item;
    for (let i = 0; i < this.items.length; i += 1) {
      const item = this.items[i];
      if (item.data.key === key) {
        $item = item.$item;
        item.active();
      }
    }
    if ($item) {
      const top = $item.offset().top - this.$scrollInfoDom.offset().top + this.$scrollInfoDom.scrollTop();
      this.$scrollInfoDom.animate({
        scrollTop: top,
      }, 500);
    }
  }

  openList(open) {
    let isOpen;
    if (open === undefined) {
      isOpen = true;
    } else {
      isOpen = open;
    }
    if (isOpen) {
      this.$listW.addClass('hide-list');
      this.listShowed = true;
    } else {
      this.$listW.removeClass('hide-list');
    }
  }

  ready() {
    // this.filterTabs = new TabGroup(
    //   this.$container.find('.filter-panel .tabs .tab'),
    //   this.$container.find('.filter-panel .filters .filter')
    // );

    // dynamicdom
    this.currentFilter = 'city'; // this.$tabCity.trigger('click');
    this.$container.find('.location-search .search-filters-input button').on('click', this.onKeywordSubmit.bind(this));

    // this.filterTabs.on('TabGroup.Change', this.onFilterTabsChange.bind(this));

    if (this.opt.exclusive) {
      this.updateMapDelay();
      this.openList(true);
    }
  }

  //   onFilterTabsChange(id) {
  //     this.currentFilter = id;
  //     switch (id) {
  //       case 'position':
  //         this.getCurrentPosition(this.updateMap.bind(this));
  //         break;
  //       default:
  //         this.updateMap();
  //         break;
  //     }
  //   }

  sendMaxnervaLog(city, area, keyword) {
    const data = {};
    if (city) data.CITY = city;
    if (area) data.AREA = area;
    if (keyword) data.KEYWORD = keyword;
    $.ajax({
      url: 'api/location_log.ashx',
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data,
    });
  }

  dynamicSort(argProperty) {
    let sortOrder = 1;
    let property = argProperty;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function sort(a, b) {
      let result;// = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      if ((a[property] < b[property])) {
        result = -1;
      } else if ((a[property] > b[property])) {
        result = 1;
      } else {
        result = 0;
      }
      return result * sortOrder;
    };
  }

  get CheckedItemData() {
    return this.checkedItemData;
  }

  get CurrentPosition() {
    if (!this.currentPosition || this.currentPosition == null) {
      this.getCurrentPosition(this.updateMap.bind(this));
    }
    return this.currentPosition;
  }
}
LocationViewer.LIST_ITEM_CHECK = 'LocationViewer.ListItemCheck';
